module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'summary-info\'></div>\n<div id=\'details-accordion\'></div>\n<div id=\'plan-accordion\'></div>\n<div id=\'special-features-accordion\'></div>\n<div id=\'system-info-accordion\'></div>\n';

}
return __p
}